import { render, staticRenderFns } from "./InsModRel.vue?vue&type=template&id=5afae2a0&scoped=true&"
import script from "./InsModRel.vue?vue&type=script&lang=js&"
export * from "./InsModRel.vue?vue&type=script&lang=js&"
import style1 from "./InsModRel.vue?vue&type=style&index=1&id=5afae2a0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afae2a0",
  null
  
)

export default component.exports